"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddressValidations = void 0;
const types_1 = require("../types");
const isRequired = (errorMessage) => (value) => !value && errorMessage;
const isStrictLength = (expectedLength, errorMessage) => (value) => value?.length !== expectedLength && errorMessage;
const isIncludedInProvince = (provinces, errorMessage) => (value, values) => {
    const province = provinces.find(({ postalCode }) => postalCode === values.province);
    const isInclude = value?.startsWith(province?.postalCode ?? '');
    return !isInclude && errorMessage;
};
const matchRegex = (regExp, errorMessage) => value => !regExp.test(value) && errorMessage;
const SHOULD_BE_NUMBER_OR_SN = /^(?:\d+|S\/N|s\/n)$/;
const POSTAL_CODE_LENGTH = 5;
function validateFieldRules({ rules, value, values }) {
    let error;
    for (const rule of rules) {
        error = rule(value, values);
        if (error) {
            break;
        }
    }
    return error;
}
function useAddressValidations({ translations, provinces }) {
    const validationSchema = {
        [types_1.AddressFieldNames.CITY]: {
            rules: [isRequired(translations.city.errors.isRequired)],
        },
        [types_1.AddressFieldNames.PROVINCE]: {
            relatedWith: [types_1.AddressFieldNames.POSTAL_CODE, types_1.AddressFieldNames.CITY],
            rules: [isRequired(translations.province.errors.isRequired)],
        },
        [types_1.AddressFieldNames.ROAD_NAME]: {
            rules: [isRequired(translations.roadName.errors.isRequired)],
        },
        [types_1.AddressFieldNames.ROAD_TYPE]: {
            rules: [isRequired(translations.roadType.errors.isRequired)],
        },
        [types_1.AddressFieldNames.POSTAL_CODE]: {
            relatedWith: [types_1.AddressFieldNames.PROVINCE],
            rules: [
                isRequired(translations.postalCode.errors.isRequired),
                isIncludedInProvince(provinces, translations.postalCode.errors.isNotIncludedInProvince),
                isStrictLength(POSTAL_CODE_LENGTH, translations.postalCode.errors.expectedLength),
            ],
        },
        [types_1.AddressFieldNames.ROAD_NUMBER]: {
            rules: [
                isRequired(translations.roadNumber.errors.isRequired),
                matchRegex(SHOULD_BE_NUMBER_OR_SN, translations.roadNumber.errors.invalidRoadNumber),
            ],
        },
    };
    const validateAll = values => {
        const errors = {};
        for (const fieldName in validationSchema) {
            if (Object.prototype.hasOwnProperty.call(validationSchema, fieldName)) {
                const { rules } = validationSchema[fieldName];
                const fieldError = validateFieldRules({ rules, values, value: values[fieldName] });
                if (fieldError) {
                    errors[fieldName] = fieldError;
                }
            }
        }
        return errors;
    };
    const validateField = ({ fieldName, value, values, prevErrors, ignoreRelations }) => {
        let errors = { ...prevErrors };
        if (validationSchema[fieldName]) {
            delete errors[fieldName];
            const { rules, relatedWith = [] } = validationSchema[fieldName];
            const fieldError = validateFieldRules({ rules, value, values });
            if (fieldError) {
                errors[fieldName] = fieldError;
            }
            for (const relatedFieldName of relatedWith) {
                if (!ignoreRelations?.includes(relatedFieldName)) {
                    errors = validateField({
                        values,
                        fieldName: relatedFieldName,
                        value: values[relatedFieldName],
                        prevErrors: errors,
                        ignoreRelations: [fieldName],
                    });
                }
            }
        }
        return errors;
    };
    return {
        validateField,
        validateAll,
    };
}
exports.useAddressValidations = useAddressValidations;
//# sourceMappingURL=useAddressValidations.js.map